import Trigger from "rc-trigger";
import { useState } from "react";
import { observer } from "mobx-react-lite";
import { withRouter } from "react-router";
import { Button, Center } from "@chakra-ui/react";

import { langStore, translate } from "@noli/business";

import { Editor_Words } from "@/utils/lang/editor";
import { themeStore } from "@/stores/theme";
import ContactUsPopup from "./Popup";
import { RIGHT_WIDTHS } from "@/utils/constants";
import { loginStore } from "@/modules/login/store";

function ContactUs() {
  const [contactUsVisible, setContactUsVisible] = useState(false);

  const lang = langStore.tgt;
  const isGuest = loginStore.isGuest;
  const { panelBg } = themeStore.styles;
  return (
    <Center w={RIGHT_WIDTHS} bottom="12px" position="absolute" right="0px" px="24px">
      <Trigger
        action={["hover"]}
        popupVisible={contactUsVisible}
        onPopupVisibleChange={setContactUsVisible}
        popup={<ContactUsPopup />}
        popupAlign={{
          points: ["bl", "tl"],
          offset: [0, -12],
        }}
      >
        <Button variant="outline" flex={1} h="32px" zIndex={1000}>
          {translate(Editor_Words["contact-us"], lang)}
        </Button>
      </Trigger>

      {isGuest ? null : (
        <Button
          as={"a"}
          href="https://wenjuan.feishu.cn/m?t=sT5PFgKEa3Gi-802j"
          target="_blank"
          variant="outline"
          // w="148px"
          flex={1}
          h="32px"
          ml="16px"
          zIndex={1000}
        >
          {translate(Editor_Words["feedback"], lang)}
        </Button>
      )}
    </Center>
  );
}

export default withRouter(observer(ContactUs));
